module.exports = __webpack_public_path__ + "img/beachvolleyWhite.621ae02c.svg";